module.exports = __webpack_public_path__ + "img/red-videoicons.9d2f0189.png";